/**
 * Name-only shim. The web app renders the scoring results card from this
 * module; the pane never receives that tool (it is gated off for the Word
 * surface), so only the constant `tool-activity.tsx` labels by is kept.
 */
export const BID_EVALUATION_RESULTS_TOOL_NAME = "show_bid_evaluation_results";
